module.exports = __webpack_public_path__ + "img/favonius-lance.00a9fb7f.webp";